/* eslint-disable max-len */
export const osnRewindEmptyIcon = {
  data: `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_21189_221230" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="5" y="29" width="19" height="19">
  <path d="M5.33301 47.9948L5.33301 29.3281H23.9997V47.9948H5.33301Z" fill="currentColor"/>
  </mask>
  <g mask="url(#mask0_21189_221230)">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.58384 33.6962L13.5311 44.9855C13.917 45.6126 14.7383 45.8082 15.3654 45.4222C15.5432 45.3128 15.6928 45.1632 15.8022 44.9855L22.7494 33.6962C23.1354 33.069 22.9398 32.2478 22.3127 31.8619C22.1025 31.7325 21.8606 31.6641 21.6139 31.6641H7.71938C6.983 31.6641 6.38605 32.261 6.38605 32.9974C6.38605 33.2441 6.45452 33.486 6.58384 33.6962Z" fill="currentColor"/>
  </g>
  <path d="M25.8979 50.7972C28.9049 52.4169 32.3451 53.3359 35.9999 53.3359C47.782 53.3359 57.3332 43.7847 57.3332 32.0026C57.3332 20.2205 47.782 10.6693 35.9999 10.6693C24.2178 10.6693 14.6666 20.2205 14.6666 32.0026V32.6693" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
  </svg>
  `,
  name: 'rewind-empty',
};
